import React, { useEffect, useState } from 'react';
import { asset } from 'Utils/envLoader';
// import { useAuth } from 'Context/auth';
import { useUserStore } from 'Store/userStore';
import PortalService from 'Services/PortalService';
import AccessService from 'Services/AccessService';
import { Link /*, useHistory*/ } from 'react-router-dom';
import { Container, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getQueryString, assignWindowLocation } from 'Utils/Helpers';

import NoDataSection from 'Components/UI/NoDataSection';

const Apps = () => {
    // const { user } = useAuth();
    const user = useUserStore((state) => state.user);
    const [accesses, setAccesses] = useState([]);
    // const history = useHistory();

    const RedirectToAppQuery =
        getQueryString(location.search, 'redirect_to') &&
        decodeURIComponent(getQueryString(location.search, 'redirect_to'));
    const RedirectToAppId =
        getQueryString(location.search, 'appId') && decodeURIComponent(getQueryString(location.search, 'appId'));

    useEffect(() => {
        if (user) {
            if (RedirectToAppId) {
                AccessService.getByUserIdAndAppId(RedirectToAppId).then((response) => {
                    onGoto(response.data.app, true);
                }).catch;
            }
            PortalService.getAccesses(user.id)
                .then((result) => {
                    if (result.status === 200) {
                        setAccesses(result.data);
                    }
                })
                .catch(() => {
                    // console.log(e);
                })
                .finally(() => {});
        }
    }, [user]);

    const onGoto = (app, refresh = false) => {
        console.log();
        if (app.disabled === true) {
            toast.warning('Cette application est actuellement désactivée.');
            return;
        }
        PortalService.goto(app.appId).then((response) => {
            let url = app.noAuth ? app.url : `${app.url}/?cliam_token=${response.data}`;
            if (app.appType === 1) url = `${app.deepLink}${response.data}`;
            const REDIRECT_TO = RedirectToAppQuery
                ? `${url.includes('?') ? '&' : '?'}redirect_to=${encodeURIComponent(RedirectToAppQuery)}`
                : '';
            const urlToGo =
                RedirectToAppQuery && RedirectToAppId && RedirectToAppId === app.appId ? `${url}${REDIRECT_TO}` : url;
            // send it
            assignWindowLocation(urlToGo);
            // if (refresh === true) history.replace('/apps');
            if (refresh === true && app.appType === 1) {
                // console.log('close please!');
                // const clientAnswer = confirm('close this page please!!');
                if (clientAnswer) {
                    setTimeout(() => {
                        window.close();
                    }, 60000);
                }
            }
            // end send it
            // console.log(refresh);
            // console.log(app);
            // console.log(url);
        });
    };

    return (
        <Container>
            <div className="row">
                <h2>&nbsp;</h2>
            </div>

            <div className="row">
                {user && user.ROLE === 'SUPERADMIN' && (
                    <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-2 card-same-height">
                        <Link to="/admin" className="custom-card-link">
                            <div className="card">
                                <img src="/images/apps/cliam.jpg" className="card-img-top" alt="cliam admin" />

                                <div className="wrapper-card-title text-center">
                                    <div className="icon-card-title">
                                        <img
                                            src="/images/super_admin.svg"
                                            alt="desktop"
                                            style={{
                                                width: '15pt',
                                            }}
                                        />
                                    </div>
                                    <div className="text-card-title">
                                        <h5>Cliam Admin</h5>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                )}
                {accesses.length ? (
                    accesses.map((access, key) => {
                        return (
                            !!access.app.listed && (
                                <div
                                    className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-2 card-same-height app-box-wrapper"
                                    key={key}
                                >
                                    <Link
                                        to="#"
                                        className="custom-card-link"
                                        onClick={() => {
                                            onGoto(access.app);
                                        }}
                                    >
                                        <div className="card">
                                            {access.app.logo ? (
                                                <img
                                                    src={
                                                        access.app.logo.startsWith('/')
                                                            ? access.app.logo
                                                            : asset + access.app.logo
                                                    }
                                                    className="card-img-top"
                                                    alt={access.app.name}
                                                />
                                            ) : (
                                                <img
                                                    src="/images/placeholder.png"
                                                    className="card-img-top"
                                                    alt="cli app"
                                                />
                                            )}
                                            <div className="wrapper-card-title text-center">
                                                <div className="icon-card-title">
                                                    {access.app.appType === 1 && (
                                                        <img
                                                            src="/images/desktop.svg"
                                                            alt="desktop"
                                                            style={{
                                                                width: '15pt',
                                                            }}
                                                        />
                                                    )}
                                                    {access.app.appType === 0 && (
                                                        <img
                                                            src="/images/web.svg"
                                                            alt="web"
                                                            style={{
                                                                width: '15pt',
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                                <div className="text-card-title">
                                                    <h5>{access.app.name}</h5>
                                                </div>
                                            </div>
                                            {/* <div className="card-body">
                                            <p className="card-text">
                                                <i></i>
                                            </p>
                                        </div> */}
                                        </div>
                                    </Link>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="button-tooltip-2">{access.app.description}</Tooltip>}
                                    >
                                        <Link className="app-box-interogation" to={`/support/${access.app.appId}`}>
                                            ?
                                        </Link>
                                    </OverlayTrigger>
                                </div>
                            )
                        );
                    })
                ) : (
                    <></>
                )}
                {user && user.ROLE !== 'SUPERADMIN' && accesses.length === 0 && (
                    <NoDataSection
                        title="Aucune app a été trouvée"
                        description="Veuillez contacter S.I. en cas de problème ou si vous avez besoin d'informations."
                    />
                )}
            </div>
        </Container>
    );
};

export default Apps;
